import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
// import ProductUpload from './ListingComponents/ProductUpload';
import ProductUpload from './ListingComponents/ProductUploadTwo';


const Listing = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState(''); // ✅ State for Username
  const [isLoggingOut, setIsLoggingOut] = useState(false); // ✅ Logout state for animation


  // ✅ Redirect to Login if User is Not Authenticated
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const storedUsername = localStorage.getItem('username'); // Retrieve username
    if (!token) {
      navigate('/');
    } else {
      setUsername(storedUsername || ''); // Set username if available
    }
  }, [navigate]);

  // ✅ Logout with Spinner Animation
  const handleLogout = () => {
    setIsLoggingOut(true); // Show loading animation

    setTimeout(() => {
      localStorage.removeItem('authToken'); // Remove token
      localStorage.removeItem('username');  // Remove username
      navigate('/login'); // Redirect to login page
    }, 3000); // Wait 3 seconds before logout
  };

  return (
    <div className="min-h-screen">
      <div className="flex w-full">
        {/* Sidebar */}
        <div className=" text-white p-6">
          <h2 className="mb-8 text-2xl font-bold whitespace-nowrap">
            Welcome : {username || 'User'} {/* ✅ Display Username Dynamically */}
          </h2>


        </div>

        {/* Main Content Area */}
        <div className="w-full p-6">
          <div className="flex justify-end items-center gap-4 mb-6">
            <div className="flex justify-end items-center gap-4">
              <Link to="/listing">

                <button className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-blue-600">Add Product</button>
              </Link>
              <Link to="/update-listing">

                <button className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-blue-600">Edit Product</button>
              </Link>
              <Link to="/delete-listing">

                <button className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-blue-600">Remove Product</button>
              </Link>

            </div>

            <Link to="/dashboard">

              <button className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-blue-600">Dashboard</button>
            </Link>
            {/* Logout Button with Spinner Animation */}
            <button
              className="bg-red-500 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-red-600 flex items-center justify-center w-[100px]"
              onClick={handleLogout}
              disabled={isLoggingOut} // Disable button while logging out
            >
              {isLoggingOut ? (
                <div className="w-6 h-6 border-4 border-white border-dashed rounded-full animate-spin"></div>
              ) : (
                "Logout"
              )}
            </button>
          </div>

        </div>

      </div>
      <ProductUpload />
    </div>
  );
};

export default Listing;
